module.exports = __webpack_public_path__ + "static/logo-a6323fdc2ba6aa9118b226623be16066.png";